<template>
  <div class="safety-file" v-if="file != null && active">
    <a
      class="button button--default download-link"
      v-if="file.Url"
      :href="file.Url"
      target="_blank"
      >{{ button }}</a
    >
  </div>
</template>

<script>
export default {
  name: 'SafetyFile',
  props: {
    file: {
      type: Object,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    button: {
      type: String,
    },
  },
}
</script>
